/* global localStorage */
/* global window */
/* global FB */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { connect } from '../../util';
import Env from '../../lib/env';
import Device from '../../lib/device';
import {
  USER_ACCESS_TOKEN,
} from '../../constants';

import CurrentUser from '../../components/current-user';
import AppFlashMessage from '../../components/app-flash-message';

class Root extends React.Component {
  componentWillMount() {
    // register device with type WEB
    const environment = Env.getCurrent();
    if (!this.props.app.bootstrap) {
      Raven.captureMessage('RegisterDevice error: bunbleId is undefined', {
        level: 'error', // one of 'info', 'warning', or 'error'
      });
    } else {
      this.props.services.app.registerDevice({
        id: Device.UUID(),
        osVersion: window.navigator.userAgent,
        appVersion: environment.version,
        bundleVersion: environment.version,
      });
    }

    const token = localStorage.getItem(USER_ACCESS_TOKEN);
    if (token) {
      this.props.actions.user.updateAccessToken(token);
    }

    this.logout = this.logout.bind(this);
    this.dismissFlashMessage = this.dismissFlashMessage.bind(this);
  }

  dismissFlashMessage() {
    this.props.actions.ux.setMessage(null);
  }

  logout() {
    if (this.props.user.currentUser.facebookId) {
      FB.logout(() => {
        this.props.services.user.logout(this.props.actions.user);
      }, e => {
        this.props.services.user.logout(this.props.actions.user);
      });
      return;
    }
    this.props.services.user.logout(this.props.actions.user);
  }

  render() {
    const message = this.props.ux.message;
    const flashMessageVisible = message.title && message.text;
    return (
      <div className={classnames({ appFlashMessageBackdrop: flashMessageVisible })}>
        <AppFlashMessage
          message={message}
          onDismiss={this.dismissFlashMessage}
        />
        <header className="userHeader">
          <CurrentUser
            user={this.props.user.currentUser}
            onLogout={this.logout}
          />
        </header>
        {this.props.children}
      </div>
    );
  }
}

Root.propTypes = {
  children: PropTypes.node,
};


export default connect(Root);



// WEBPACK FOOTER //
// ./src/containers/root/index.js